function __(tag, block) {
  block.tag = tag;
  return block;
}

export { __ };
/* No side effect */